import React, { useEffect, useMemo, useState } from 'react';
import Paragraph from 'app_previous/elements/typography/paragraph';
import { decodeHtmlEntities } from 'src/functions/decodeHtmlEntities';
import { palette } from 'app_previous/styles/colors';
import { NameSuggestionContainer, NameSuggestionPrefix } from './NameSuggestion.styles';

interface NameSuggestionProps {
  name: string;
  animated: boolean;
  delayTimeInMilliseconds?: number;
  backgroundColor?: string;
  textColor?: string;
  generatorSubject?: string;
}

const NameSuggestion = ({
  name,
  animated,
  delayTimeInMilliseconds,
  backgroundColor = 'rgba(255, 255, 255, 0.6)',
  textColor = palette.darkGray,
  generatorSubject,
}: NameSuggestionProps): JSX.Element => {
  const [visible, setVisible] = useState(!animated);

  const beautifyName = useMemo(() => {
    const decodedName = decodeHtmlEntities(name);

    if (generatorSubject === 'network_name_generator') {
      return decodedName;
    }

    const parts = decodedName.split(':');

    if (parts.length > 1) {
      return (
        <>
          <NameSuggestionPrefix>{parts[0]}:</NameSuggestionPrefix>
          {parts.slice(1).join(':')}
        </>
      );
    }

    return decodedName;
  }, [generatorSubject, name]);

  useEffect(() => {
    if (animated) {
      setTimeout(() => {
        setVisible(true);
      }, delayTimeInMilliseconds ?? 0);
    }
  }, [animated]);

  return (
    <NameSuggestionContainer
      visible={visible}
      delayTimeInMilliseconds={delayTimeInMilliseconds}
      backgroundColor={backgroundColor}
    >
      <Paragraph
        standardSize='1.125'
        align='center'
        weight={400}
        color={textColor}
      >
        {beautifyName}
      </Paragraph>
    </NameSuggestionContainer>
  );
};

export default NameSuggestion;
